module.exports = __webpack_public_path__ + "img/chongci_ps_26.79223c29.jpg";